module.exports = __webpack_public_path__ + "static/media/output-onlinepngtools.de9cd91e.png";